import React, { useEffect, useState } from "react";
import { Col, Modal, ModalBody, Row } from "reactstrap";
import Title from "../title";
import { ComonIcons } from "../../contents/commonIcons";
import SpinnerComponent from "../spinner/spinner";

export const ImportDataPopup = ({ }) => {

  const toggle = () => {};

  useEffect(() => {
  }, []);

  return (
    <Modal
      isOpen={true}
      centered={true}
      size={"lg"}
      autoFocus={false}
      className="large-pop adding-popup"
      toggle={toggle}
    >
      <ModalBody>
        <div className="bg-white mx-2">
          <div className="d-flex align-items-center border-bottom-1 pb-4 mb-4">
            <div className="d-inline-flex ">
              <Title title="Importing Data" />
            </div>
          </div>
          <div className="member-info-wrapper info-wrapper blk-padding-y" style={{ height: "50vh", maxHeight: "50vh", textAlign: "center" }}>
            <div className="info trainer-info h-100">
              <div
                className="d-flex flex-column align-items-center justify-content-center h-50">
                <br/>
                <SpinnerComponent/>
                <h3 className="mt-5">Importing Data in progress, please wait..</h3>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}